enum StampIcon {

  NONE = '',
  CANCELED = 'canceled',
  CANCELED_OUTLINE = 'canceled_outline',
  CHECK = 'check',
  CLOCK = 'waiting',
  LOCALE = 'locale',
  WARNING = 'warning',

}

export default StampIcon;
